/**
 * <s-sticky-header target="hero-id">
 *
 * Wraps the site header. When a `target` element id is given, the header is
 * treated as transparent while that element sits beneath it, and the
 * `data-scrolled` attribute is set once the visitor scrolls past it, letting
 * the header switch to its solid style through `group-data-[scrolled]` utilities.
 * Without a target, the element does nothing.
 */
class StickyHeader extends HTMLElement {
  connectedCallback() {
    const targetId = this.getAttribute('target');
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) {
      this.toggleAttribute('data-scrolled', true);
      return;
    }

    const header = this.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 72;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.toggleAttribute('data-scrolled', !entry.isIntersecting);
      },
      { rootMargin: `-${headerHeight}px 0px 0px 0px`, threshold: 0 }
    );
    this.observer.observe(target);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.observer = null;
  }
}

if (!customElements.get('s-sticky-header')) {
  customElements.define('s-sticky-header', StickyHeader);
}
